const footerGroups = [
  {
    title: "内容导航",
    links: [
      { id: "synopsis", label: "作品简介" },
      { id: "versions", label: "版本一览" },
      { id: "characters", label: "人物角色" },
      { id: "episodes", label: "分集看点" },
    ],
  },
  {
    title: "观看相关",
    links: [
      { id: "gallery", label: "精彩剧照" },
      { id: "guide", label: "观看指南" },
      { id: "reviews", label: "观众口碑" },
      { id: "faq", label: "常见问题" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="w-full max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-secondary-500 text-background-50 flex items-center justify-center">
                <i className="ri-home-heart-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">漂亮的保姆</span>
            </div>
            <p className="mt-4 text-foreground-600 text-sm leading-relaxed max-w-sm">
              本页为《漂亮的保姆》影视作品的信息导览入口，汇总电影、电视剧与短剧版本的基本信息，方便你快速了解并选择合适的观看方式。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["电影版", "电视剧版", "短剧版"].map((t) => (
                <span key={t} className="px-3 py-1 rounded-full bg-background-50 text-secondary-900 text-xs">
                  {t}
                </span>
              ))}
            </div>
          </div>

          {footerGroups.map((group) => (
            <nav key={group.title} className="md:col-span-3">
              <h4 className="font-heading text-sm font-semibold text-foreground-950 tracking-wide">{group.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      className="text-foreground-600 hover:text-primary-700 text-sm cursor-pointer transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="md:col-span-1"></div>
        </div>

        <div className="w-full max-w-6xl mx-auto mt-10 md:mt-12 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs md:text-sm text-foreground-500">
          <p>© 2026 漂亮的保姆 · 作品信息导览页</p>
          <p>页面内容仅供信息参考，不提供在线播放与下载服务</p>
        </div>
      </div>
    </footer>
  );
}